import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Language: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.89362 3.21277C3.63866 3.21277 1 5.85143 1 9.10639C1 10.2475 1.32462 11.3125 1.88607 12.215L1 14.751L3.89245 14.1792C4.77155 14.7005 5.79753 15 6.89362 15C10.1486 15 12.7872 12.3614 12.7872 9.10639C12.7872 5.85143 10.1486 3.21277 6.89362 3.21277Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99658 3.2803C7.07445 1.88578 8.75315 1 10.652 1C13.907 0.999968 16.5457 3.63862 16.5457 6.89359C16.5457 8.03468 16.221 9.09974 15.6596 10.0022L16.5457 12.5382L13.6532 11.9664C13.0325 12.3345 12.2901 12.6069 11.5498 12.7264"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.19775 8.41064V9.80194"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.04541 7.39417V10.8181"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.89355 8.41064V9.80194"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.74121 7.87451V10.3381"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5898 8.79578V9.41638"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

Language.displayName = 'Language'
